'use client';

import useIsFocusVisible from '@mui/utils/useIsFocusVisible';
export default useIsFocusVisible;